import { render, staticRenderFns } from "./FormComment.vue?vue&type=template&id=7a5909e6&scoped=true&"
import script from "./FormComment.vue?vue&type=script&lang=js&"
export * from "./FormComment.vue?vue&type=script&lang=js&"
import style0 from "./FormComment.vue?vue&type=style&index=0&id=7a5909e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5909e6",
  null
  
)

export default component.exports